import script from "./audit-patient-dialog.vue?vue&type=script&lang=ts&setup=true&name=AuditPatientDialog"
export * from "./audit-patient-dialog.vue?vue&type=script&lang=ts&setup=true&name=AuditPatientDialog"

const __exports__ = script;

export default __exports__